import { render, staticRenderFns } from "./WorkAndStudyRights.vue?vue&type=template&id=34c43c24&"
import script from "./WorkAndStudyRights.vue?vue&type=script&lang=js&"
export * from "./WorkAndStudyRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports